const PERMISSION_KEY= "core:user_cash_transaction";
const PAGE_URL = {
    USER_CASH_TRANSACTION_PAGE: "/admin/core/user-cash-transaction"
}

export {PERMISSION_KEY, PAGE_URL}

